import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  "aria-label": "breadcrumb"
}
const _hoisted_2 = { class: "breadcrumb" }
const _hoisted_3 = { class: "breadcrumb-item" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" ホーム ")
const _hoisted_5 = {
  key: 0,
  class: "breadcrumb-item"
}
const _hoisted_6 = {
  key: 1,
  class: "breadcrumb-item active",
  "aria-current": "page"
}

import { watch, reactive, ref } from "vue";
import { RouteLocationMatched, useRoute} from "vue-router";
import _ from 'lodash';


export default /*#__PURE__*/_defineComponent({
  __name: 'BreadCrumb',
  setup(__props) {

const route = reactive(useRoute())
const urls:RouteLocationMatched[] = []
var arry = reactive({urls})
const breadCrumb = ref()
watch(
  () => _.cloneDeep(route),
  (route) => {
    if (route.matched) {
      arry.urls = []
      const links = route.matched.filter((item:RouteLocationMatched) => item.meta.title)
      links.forEach(function(link:RouteLocationMatched) {
        breadCrumb.value = link.meta.breadCrumb
        var params = route.params
        let afterUrl = link.path //加工前後のURLを判定するため
        for (const [paramKey, val] of Object.entries(params)) {
          const paramId:string|string[] = val
          if (typeof paramId=="string") {
            afterUrl = afterUrl.replace(':'+paramKey, paramId)
          }
        }
        link.path = afterUrl
        //「自ページ以外のmeta.skip:trueとなっているデータ」以外を格納
        if (!(afterUrl!=route.path && (breadCrumb.value!=null && breadCrumb.value.skipRoute!=null && breadCrumb.value.skipRoute))) {
          arry.urls.push(link)
        }
      })
    }
  },
  { deep: true, immediate: true }
)



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.$route.meta.title!=null)
    ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
        _createElementVNode("ol", _hoisted_2, [
          _createElementVNode("li", _hoisted_3, [
            _createVNode(_component_router_link, {
              to: "/",
              class: "l-breadcrumb__text",
              role: "button"
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(arry).urls, (url) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: url.path
            }, [
              (url.path != _ctx.$route.fullPath)
                ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                    (url.path != _ctx.$route.fullPath)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: url.path
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(url.meta.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("li", _hoisted_6, _toDisplayString(url.meta.title), 1))
            ], 64))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})